import { Box, Typography, Paper } from "@mui/material";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { colors } from "../../../ui/colors";
import { InfoItem, InfoSection } from "../../components/SectionInformation";

export const ReviewInformationForm = ({ formData, handleEditStepper }) => {
    const {
        firstName,
        lastName,
        email,
        phone,
        countryCode,
        companyName,
        employerIdNumber,
        mailingAddress,
        companyRole,
        businessStructure
    } = formData;

    return (
        <Box sx={{ width: '100%' }}>

            <Typography
                variant="h6"
                sx={{
                    mb: 3,
                    ml: 3,
                    color: colors.gray.base,
                    fontWeight: 600,
                    fontSize: '20px'
                }}
            >
                Take a quick look: is everything right?
            </Typography>

            <InfoSection title="Account Information" icon={<BorderColorIcon />} onEdit={() => handleEditStepper(0)}>
                <Box sx={{ display: 'flex', gap: 3, mb: 1 }}>
                    <Box sx={{ flex: 1 }}>
                        <InfoItem label="Name*" value={firstName} />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <InfoItem label="Last Name*" value={lastName} />
                    </Box>
                </Box>

                <InfoItem label="Email*" value={email} />

                <Box sx={{ display: "flex", gap: 3, mb: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <InfoItem label="Country code*" value={countryCode} />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <InfoItem label="Phone*" value={phone} />
                    </Box>
                </Box>
            </InfoSection>

            <InfoSection title="Business Information" icon={<BorderColorIcon />} onEdit={() => handleEditStepper(1)}>
                <Box sx={{ display: 'flex', gap: 3, mb: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <InfoItem label="Company Name*" value={companyName} />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <InfoItem
                            label="Employer Identification Number"
                            value={employerIdNumber}
                        />
                    </Box>
                </Box>

                <Box sx={{ mb: 2 }}>
                    <InfoItem label="Mailing Address*" value={mailingAddress} />
                </Box>

                <Box sx={{ display: 'flex', gap: 3 }}>
                    <Box sx={{ flex: 1 }}>
                        <InfoItem label="Company Role*" value={companyRole} />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <InfoItem label="Business Structure*" value={businessStructure} />
                    </Box>
                </Box>
            </InfoSection>
        </Box>
    );
};

